import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Nav } from "./components/Nav";
import { Admin } from "./pages/Admin";
import { AdminLogin } from "./pages/AdminLogin";
import { Login } from "./pages/Login";
import { MyAccount } from "./pages/MyAccount";
import { Storefront } from "./pages/Storefront";
import { Cancel, Success } from "./pages/Success";
import { useAdmin } from "./hooks/useAdmin";
import "./App.css";

function RequireAdmin({ children }: { children: JSX.Element }) {
  const { admin, loading } = useAdmin();
  if (loading) return <p className="page-hint">Verificando sessão...</p>;
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <BrowserRouter>
      <Nav />
      <main className="page">
        <Routes>
          <Route path="/" element={<Navigate to="/loja" replace />} />
          <Route path="/login" element={<Login />} />
          <Route path="/loja" element={<Storefront />} />
          <Route path="/loja/success" element={<Success />} />
          <Route path="/loja/cancel" element={<Cancel />} />
          <Route path="/conta" element={<MyAccount />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <RequireAdmin>
                <Admin />
              </RequireAdmin>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </BrowserRouter>
  );
}

export default App;
